var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-divider"},[_c('div',{staticClass:"section-heading"},[_c('span',{staticClass:"divider-line"}),_c('div',{staticClass:"section-heading-content"},[_c('h3',{staticClass:"view-rooms vr"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('lbl_explore_our_rooms')))]})],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }